module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.tagType, _vm._b({
    tag: "div",
    staticClass: "Feature"
  }, 'div', _vm.featureAttributes, false), [_c('thumbnail', {
    attrs: {
      "image": _vm.getImage(_vm.image),
      "tags": _vm.resolvedTags
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1b218f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Feature.vue
// module id = 801
// module chunks = 1474